import { getSharedStyles } from '../../themes';
import React, { PureComponent } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import clsx from 'classnames';
import FMPText from '../../components/pureForm/FMPText';
import update from 'immutability-helper';

const pBlue = '#0790CB';
const styles = (theme) => ({
	...getSharedStyles(theme),
	blockPickerContainer: {
		padding: `7px 15px 10px 15px`,
	},
	fieldDisplay: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#666',
		//fontWeight : 600,
	},
	nothingPicked: {
		fontStyle: 'italic',
		fontWeight: 200,
		color: '#999',
	},
	currentlyPicking: {
		fontStyle: 'italic',
		fontWeight: 600,
		color: pBlue,
	},
	valueDisplay: {
		marginTop: 5,
		marginBottom: 10,
	},
	keyBlockText: {
		padding: 7,
		display: 'inline-block',
		border: `1px solid #bbb`,
		borderRadius: 3,
		fontWeight: 600,
		color: '#555',
	},
	valueBlockText: {
		backgroundColor: '#eee',
		color: '#999',
		borderRadius: '3px',
		padding: 10,
		display: 'inlineBlock',
	},
	blockPickingContainerIsPicking: {
		borderLeft: `4px solid ${pBlue}`,
		backgroundColor: '#e6f7ff',
	},
	blockPickingContainerNoPicking: {
		borderLeft: '2px solid #bbb',
	},
	blockPickerButton: {
		borderRadius: 100,
		textTransform: 'uppercase',
		padding: '5px 15px',
	},
});

class BlockPicker extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isActive: false,
		};
	}

	handleOnStartPicking = () => {
		const { isActive } = this.state;
		const { cancelPicking, value } = this.props;

		if (!isActive) {
			if (_.isEmpty(value.keyBlock)) {
				this.setState({ isActive: true });
				this.startPickingKeyBlock();
			} else {
				this.clearValue();
			}
		} else {
			this.setState({ isActive: false });
			cancelPicking();
		}
	};

	componentDidUpdate(prevProps) {
		const { isActive } = this.state;
		if (!isActive) {
			return;
		}
		const { value, cancelPicking, type } = this.props;

		//- keyChanged now start picking value
		if (value !== prevProps.value) {
			if (value.keyBlock && _.isEmpty(prevProps.value.keyBlock)) {
				if (type === 'keyAndValue') {
					this.startPickingValueBlock();
				} else {
					this.setState({ isActive: false });
					cancelPicking();
				}
			} else if (value.valueBlock !== prevProps.value.valueBlock) {
				this.setState({ isActive: false });
				cancelPicking();
			}
		}
	}

	startPickingKeyBlock = () => {
		const { startPicking, type, path } = this.props;

		let pickingType = 'indicatorBlocks';
		if (type === 'keyAndValue') {
			pickingType = 'anchorBlocks';
		}

		startPicking({
			path: path + '.keyBlock',
			pickingType,
		});
	};

	startPickingValueBlock = () => {
		const { startPicking, path } = this.props;

		//- single blocks never get here

		let pickingType = 'allBlocks';
		startPicking({
			path: path + '.valueBlock',
			pickingType,
		});
	};
	clearValue = () => {
		const { path, onChange, value } = this.props;
		const newValue = {
			field: value.field,
			display: value.display,
			keyBlock: {},
			valueBlock: {},
		};
		onChange(newValue, path);
	};

	handleLocalChange = (value, path) => {
		//this.onChange(value, path, error);
		const newValue = update(this.props.value, {
			[path]: { $set: value },
		});

		this.props.onChange(newValue, this.props.path);
	};

	render() {
		const { isActive } = this.state;
		const { value, error, md, classes, type, showDateFormat } = this.props;

		if (!_.isObject(value)) {
			return <div>ERROR! Invalid value.</div>;
		}

		//value.field (for the db)
		const { display, keyBlock, valueBlock, dateFormat, valueRegex } = value;
		let hasKeyBlock = _.isObject(keyBlock) && !_.isEmpty(_.keys(keyBlock));
		let hasValueBlock = _.isObject(valueBlock) && !_.isEmpty(_.keys(valueBlock));
		let hasBothBlocks = hasKeyBlock & hasValueBlock;

		let keyDisplay;
		if (hasKeyBlock) {
			keyDisplay = <div className={classes.keyBlockText}>{keyBlock.Text}</div>;
		} else {
			if (isActive) {
				keyDisplay = <span className={classes.currentlyPicking}>Pick the anchor block</span>;
			} else {
				keyDisplay = <span className={classes.nothingPicked}>Nothing picked yet...</span>;
			}
		}

		let valueDisplay;
		if (hasValueBlock) {
			valueDisplay = <div className={classes.valueBlockText}>{valueBlock.Text}</div>;
		} else {
			if (isActive) {
				if (hasKeyBlock) {
					valueDisplay = <span className={classes.currentlyPicking}>Pick the value block</span>;
				}
			}
		}

		let valueRegexDisplay;
		if (hasValueBlock) {
			valueRegexDisplay = (
				<FMPText
					label={'Value Regex'}
					path={'valueRegex'}
					value={valueRegex || ''}
					onChange={this.handleLocalChange}
				/>
			);
		}

		let dateFormatDisplay;
		if (showDateFormat && hasValueBlock) {
			dateFormatDisplay = (
				<div className={classes.valueDisplay}>
					<FMPText
						label={'Date Format'}
						path={'dateFormat'}
						value={dateFormat || ''}
						onChange={this.handleLocalChange}
					/>
				</div>
			);
		}

		let variant, buttonText;
		let modeClass = 'blockPickingContainerNoPicking';
		if (isActive) {
			variant = 'outlined';
			buttonText = 'Cancel';
			modeClass = 'blockPickingContainerIsPicking';
		} else if (hasBothBlocks) {
			variant = 'outlined';
			buttonText = 'Clear';
		} else {
			variant = 'contained';
			buttonText = 'Pick';
		}

		const hasError = !!error;
		return (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError} margin={'dense'}>
					<div className={clsx(classes.blockPickerContainer, classes[modeClass])}>
						{display && <div className={classes.fieldDisplay}>{display}</div>}

						<div className={classes.valueDisplay}>{keyDisplay}</div>

						{type === 'keyAndValue' && (
							<>
								<div className={classes.valueDisplay}>{valueDisplay}</div>
								<div className={classes.valueDisplay}>{valueRegexDisplay}</div>
								{dateFormatDisplay}
							</>
						)}

						<Button
							className={classes.blockPickerButton}
							variant={variant}
							size="small"
							color={'primary'}
							onClick={this.handleOnStartPicking}
						>
							{buttonText}
						</Button>
					</div>
				</FormControl>
				{hasError && <FormHelperText>{error}</FormHelperText>}
			</Grid>
		);
	}
}

BlockPicker.propTypes = {
	classes: PropTypes.object,
	type: PropTypes.string,

	value: PropTypes.object,
	path: PropTypes.string.isRequired,
	startPicking: PropTypes.func.isRequired,
	cancelPicking: PropTypes.func.isRequired,

	md: PropTypes.number,
	error: PropTypes.string,

	onChange: PropTypes.func.isRequired,
	showDateFormat: PropTypes.bool,
	//helpText : PropTypes.string,
	//contained : PropTypes.bool,
	//disabled : PropTypes.bool,
};

BlockPicker.defaultProps = {
	type: 'key',
};

export default _.flow([withStyles(styles, { withTheme: true })])(BlockPicker);
